module.exports = __webpack_public_path__ + "static/media/rewind.6990fb01.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Sounds/rewind.mp3
// module id = 40
// module chunks = 1